import React from 'react';
import { ShieldCheck, Sparkles } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Guarantee() {
  return <section className="py-8 md:py-16 bg-brand-orange/5 border-y border-brand-orange/20" data-id="element-99">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-100">
        <FadeIn data-id="element-101">
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6 text-center md:text-left" data-id="element-102">
            {/* Seal */}
            <div className="relative shrink-0" data-id="element-103">
              <div className="absolute inset-0 bg-brand-orange/20 rounded-full blur-xl" data-id="element-104" />
              <div className="relative w-20 h-20 md:w-24 md:h-24 rounded-full bg-gradient-to-br from-brand-orange/30 to-brand-orange/10 border-2 border-brand-orange/40 flex flex-col items-center justify-center" data-id="element-105">
                <ShieldCheck className="w-7 h-7 md:w-9 md:h-9 text-brand-orange" data-id="element-106" />
                <span className="text-[9px] md:text-[10px] font-display tracking-widest text-brand-orange mt-0.5" data-id="element-107">
                  7 DÍAS
                </span>
              </div>
            </div>

            {/* Content */}
            <div className="flex-grow" data-id="element-108">
              <div className="inline-flex items-center gap-1.5 bg-brand-orange/10 border border-brand-orange/30 text-brand-orange px-2.5 py-0.5 rounded-full text-[10px] md:text-xs font-bold tracking-widest mb-2 md:mb-3" data-id="element-109">
                <Sparkles className="w-3 h-3" data-id="element-110" /> GARANTÍA TOTAL
              </div>
              <h2 className="text-xl md:text-3xl mb-2 md:mb-3 leading-tight text-glow" data-id="element-111">
                7 días para probarlo o{' '}
                <span className="text-brand-orange" data-id="element-112">te devolvemos el 100%</span>
              </h2>
              <p className="text-xs md:text-sm text-brand-muted leading-relaxed" data-id="element-113">
                Abrís los módulos, probás los bonos en tu barra o anillas. Si no
                es lo que esperabas:{' '}
                <strong className="text-brand-text" data-id="element-114">
                  sin preguntas, sin formularios, sin drama.
                </strong>{' '}
                <span className="text-brand-muted/80" data-id="element-115">
                  (Tasa de devoluciones &lt; 1%)
                </span>
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}